module.exports = __webpack_public_path__ + "img/member_center_footer2.2dccc090.png";